"use client";

import React, { useState } from "react";
import { Button, Col, Divider, Row, Switch, Typography } from "antd/lib";
import Paragraph from "antd/lib/typography/Paragraph";
import Title from "antd/lib/typography/Title";
import { useTranslation } from "react-i18next";
import { App } from "antd";
import { LocalStorageKeys } from "@/constants/common";

const { Text } = Typography;

type CookieConsentProps = {
  onClose?: () => void;
};

const CookieConsent: React.FC<CookieConsentProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  const [necessaryCookies, setNecessaryCookies] = useState(true);
  const [performanceCookies, setPerformanceCookies] = useState(true);

  const handleSetCookieSettings = () => {
    localStorage.setItem(LocalStorageKeys.necessaryCookies, JSON.stringify(necessaryCookies));
    localStorage.setItem(LocalStorageKeys.performanceCookies, JSON.stringify(performanceCookies));

    if (onClose) onClose();
    message.success(t("cookieConsent.message"));
  };

  const handleNecessaryCookiesChange = (checked: boolean) => {
    setNecessaryCookies(checked);
    if (!checked) {
      setPerformanceCookies(false);
    }
  };

  const canSetCookieSettings = necessaryCookies || performanceCookies;

  return (
    <Row justify="center" align="middle" style={{ padding: "1rem" }}>
      <Col span={24}>
        <Typography>
          <Title level={2} style={{ textAlign: "center" }}>
            {t("cookieConsent.title")}
          </Title>
          <Title level={3} style={{ textAlign: "center" }}>
            {t("cookieConsent.subTitle")}
          </Title>

          <Paragraph style={{ textAlign: "center" }}>{t("cookieConsent.description")}</Paragraph>

          <Divider />

          <Title level={4}>{t("cookieConsent.strictlyNecessaryCookies")}</Title>
          <Paragraph>
            {t("cookieConsent.cookiesEssential")} <Text strong>{t("cookieConsent.withoutTheseCookies")}</Text>
            {t("cookieConsent.ifThisCookies")}
          </Paragraph>
          <Switch
            checkedChildren={t("cookieConsent.on")}
            unCheckedChildren={t("cookieConsent.off")}
            checked={necessaryCookies}
            onChange={handleNecessaryCookiesChange}
          />

          <Divider />

          <Title level={4}>{t("cookieConsent.performanceNecessaryCookies")}</Title>
          <Paragraph>{t("cookieConsent.cookiesPerformance")}</Paragraph>
          <Switch
            checkedChildren={t("cookieConsent.on")}
            unCheckedChildren={t("cookieConsent.off")}
            checked={performanceCookies}
            onChange={setPerformanceCookies}
            disabled={!necessaryCookies}
          />

          <Divider />

          <Row justify="center">
            <Button type="primary" onClick={handleSetCookieSettings} disabled={!canSetCookieSettings}>
              {t("cookieConsent.button")}
            </Button>
          </Row>
        </Typography>
      </Col>
    </Row>
  );
};
export default CookieConsent;
